export function isBillableCptCode(code: string | null | undefined): boolean {
  const normalized =
    code
      ?.trim()
      .replace(/\s*[gG]$/, "")
      .toUpperCase() ?? "";
  const baseCode = normalized.slice(0, 5);
  return /^[A-Z0-9]{5}$/.test(baseCode) && /\d/.test(baseCode);
}
